import type { RouteObject } from "react-router-dom";
import { redirect } from "react-router-dom";
import { addSlashes } from "../route.utils";
import { Spinner } from "@/components/ui/v2/spinner";
import {
  MsExpenses,
  MsMyExpensesPage,
  MsMyReimbursementsPage,
  MsExpenseDetail,
  MsExpenseCreate,
  MsExpenseEdit,
  MsReimbursementDetail,
} from "@/utils/lazyLoadComponents";

export enum MS_EXPENSES_PATH_SEGMENTS {
  ROOT = "expenses",
  MY_EXPENSES = "my-expenses",
  MY_REIMBURSEMENTS = "my-reimbursements",
  CREATE = "create",
  REIMBURSEMENT_DETAIL = "my-reimbursements/:id",
  EDIT = ":id/edit",
  DETAILS = ":id",
}

export const mySpaceExpensesRoutes: RouteObject = {
  path: MS_EXPENSES_PATH_SEGMENTS.ROOT,
  handle: { breadcrumb: "Expenses" },
  HydrateFallback: Spinner,
  children: [
    // ── Page-level tabs layout: each tab owns its own stats + table ──────────
    {
      Component: MsExpenses,
      handle: { flushContent: true },
      children: [
        {
          index: true,
          loader: () => redirect(MS_EXPENSES_PATH_SEGMENTS.MY_EXPENSES),
        },
        {
          path: MS_EXPENSES_PATH_SEGMENTS.MY_EXPENSES,
          handle: { breadcrumb: "My Expenses" },
          Component: MsMyExpensesPage,
        },
        {
          path: MS_EXPENSES_PATH_SEGMENTS.MY_REIMBURSEMENTS,
          handle: { breadcrumb: "My Reimbursements" },
          Component: MsMyReimbursementsPage,
        },
      ],
    },
    {
      path: MS_EXPENSES_PATH_SEGMENTS.REIMBURSEMENT_DETAIL,
      handle: { breadcrumb: "Reimbursement" },
      Component: MsReimbursementDetail,
    },
    {
      path: MS_EXPENSES_PATH_SEGMENTS.CREATE,
      handle: { breadcrumb: "Submit Expense" },
      Component: MsExpenseCreate,
    },
    {
      path: MS_EXPENSES_PATH_SEGMENTS.EDIT,
      handle: { breadcrumb: "Edit Expense" },
      Component: MsExpenseEdit,
    },
    {
      path: MS_EXPENSES_PATH_SEGMENTS.DETAILS,
      handle: { breadcrumb: "Expense Details" },
      Component: MsExpenseDetail,
    },
  ],
};

export const MS_EXPENSES_PATHS = Object.freeze({
  ROOT: addSlashes(MS_EXPENSES_PATH_SEGMENTS.ROOT),
  MY_EXPENSES: addSlashes(
    MS_EXPENSES_PATH_SEGMENTS.ROOT,
    MS_EXPENSES_PATH_SEGMENTS.MY_EXPENSES,
  ),
  MY_REIMBURSEMENTS: addSlashes(
    MS_EXPENSES_PATH_SEGMENTS.ROOT,
    MS_EXPENSES_PATH_SEGMENTS.MY_REIMBURSEMENTS,
  ),
  CREATE: addSlashes(
    MS_EXPENSES_PATH_SEGMENTS.ROOT,
    MS_EXPENSES_PATH_SEGMENTS.CREATE,
  ),
  EDIT: (id: string | number) =>
    addSlashes(MS_EXPENSES_PATH_SEGMENTS.ROOT, String(id), "edit"),
  REIMBURSEMENT_DETAIL: (id: string | number) =>
    addSlashes(
      MS_EXPENSES_PATH_SEGMENTS.ROOT,
      MS_EXPENSES_PATH_SEGMENTS.MY_REIMBURSEMENTS,
      String(id),
    ),
  DETAIL: (id: string | number) =>
    addSlashes(MS_EXPENSES_PATH_SEGMENTS.ROOT, String(id)),
});
